import { render, staticRenderFns } from "./billing-act-viewer.vue?vue&type=template&id=a7c52e56&scoped=true&lang=pug"
import script from "./billing-act-viewer.vue?vue&type=script&lang=js"
export * from "./billing-act-viewer.vue?vue&type=script&lang=js"
import style0 from "./billing-act-viewer.vue?vue&type=style&index=0&id=a7c52e56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c52e56",
  null
  
)

export default component.exports